import {getCookies} from '../../../utils/getters/getCookies';

export const initTip = ( apartmentCard ) => {
	const tip = apartmentCard.querySelector( 'div.tip' );

	if ( !tip )
	{
		return;
	}

	const currentCookies = getCookies();

	const hideTip = () => {
		const today = new Date();
		const expires = new Date();

		tip.removeEventListener( 'click', hideTip );
		tip.remove();
		expires.setTime( today.getTime() + 1000 * 60 * 60 * 24 * 14 );
		document.cookie = `tip_click_to_hide_furniture=tip_click_to_hide_furniture; expires=${expires.toGMTString()}; path=/`;
	};

	if ( currentCookies['tip_click_to_hide_furniture'] )
	{
		tip.remove();
	}
	else
	{
		tip.addEventListener( 'click', hideTip );

		setTimeout( () => {
			tip.remove();
		}, 3000 );
	}
};